import React from 'react';
import { Link } from 'react-router-dom';

const AccountDropdown = ({ isLoggedIn, location, updateParentUserDataState }) => {
    if (isLoggedIn) {
        return (
            <div className="dropdn dropdn_account dropdn_fullheight is-loggedin account-wrapper">
                <span className="dropdn-link js-dropdn-link js-dropdn-link only-icon account-link">
                    <i className="icon-user" /><span className="dropdn-link-txt">Account</span>
                </span>
                <div className="account-details">
                    <div className="account-placeholder"></div>
                    <ul className="loggedin-userdata">
                        <li>
                            <Link to="/account-details">
                                <span className={`dropdn-link-txt ${location.pathname.includes("/account-details") ? "text-primary" : ""}`}>Account Details</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/account-addresses">
                                <span className={`dropdn-link-txt ${location.pathname.includes("/account-addresses") ? "text-primary" : ""}`}>My Addresses</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/account-wishlist">
                                <span className={`dropdn-link-txt ${location.pathname.includes("/account-wishlist") ? "text-primary" : ""}`}>My Wishlist</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/account-history">
                                <span className={`dropdn-link-txt ${location.pathname.includes("/account-history") ? "text-primary" : ""}`}>My Order History</span>
                            </Link>
                        </li>
                        {/* Static Links */}
                        {["Purchase Order Management", "Sales Order Management", "Seller Management", "Complex Transaction List", "Billing Management", "RMA Management", "Inventory Management", "Buyer Protection Management", "External Platform Mapping", "Sales and Puchase Agreement", "My Coupon"].map((label, idx) => (
                            <li key={idx}>
                                <Link to="">
                                    <span className="dropdn-link-txt">{label}</span>
                                </Link>
                            </li>
                        ))}
                        <li className="separator"></li>
                        <li>
                            <Link to="/logout">
                                <span className="dropdn-link-txt">Logout</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    } else {
        return (
            <div className="dropdn dropdn_account dropdn_fullheightt account-wrapper">
                <span className="dropdn-link js-dropdn-link js-dropdn-link only-icon account-link">
                    <i className="icon-user" /><span className="dropdn-link-txt">Account</span>
                </span>
                <div className="account-details">
                    <div className="account-placeholder"></div>
                    <ul className="loggedin-userdata">
                        <li>
                            <p className="welcome-back">Welcome back</p>
                            <Link to="/login" className="loginBtn">Login</Link>
                        </li>
                        <li>
                            <p className="new-customer">New Customer ?</p>
                            <Link to="/register" className="registerBtn">Register</Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
};

export default AccountDropdown;
